import { render, staticRenderFns } from "./hangye.vue?vue&type=template&id=090d0f34&scoped=true&"
import script from "./hangye.vue?vue&type=script&lang=js&"
export * from "./hangye.vue?vue&type=script&lang=js&"
import style0 from "./hangye.vue?vue&type=style&index=0&id=090d0f34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090d0f34",
  null
  
)

export default component.exports